import React from 'react';
import { useMutation, useQuery } from '@apollo/client';

import { isEmpty } from 'lodash';
import moment from 'moment';
import { string, func } from 'prop-types';

import { captureException, ErrorHandler } from '@playbookux/playbook-web-core';
import {
  Column,
  Container,
  Data,
  Grid,
  Header,
  Link,
  NoDataMessage,
  Row,
} from './styles';

import {
  ClickableData,
  Loader,
} from '../../styles';

import { REPROCESS_VIDEO } from '../../../../../core/graphql/test-sessions';
import { GET_TESTERS_EXPIRED } from './graphql';

const ExpiredTesters = (props) => {
  const {
    onSetCurrentTester,
    testType,
    refetch,
    projectId,
  } = props;
  const [reprocessVideo] = useMutation(REPROCESS_VIDEO, {
    onCompleted: refetch,
  });

  const { loading, errors, data = {} } = useQuery(GET_TESTERS_EXPIRED, {
    variables: {
      projectId,
    },
    fetchPolicy: 'network-only',
  });
  const { testSessionsExpired = {} } = data;

  const handleReprocessVideo = async (id) => {
    try {
      await reprocessVideo({
        variables: {
          testSessionId: id,
        },
      });
    } catch (e) {
      captureException('HANDLE_REPROCESS_VIDEO_EXPIRED_FAILED', e);
    }
  };

  if (loading) {
    return <Loader size="small" data-loader="expired-menu-loader" />;
  }

  if (errors) {
    return (
      <ErrorHandler
        error={errors}
        defaultMessage="Error while retrieving the testers."
      />
    );
  }

  return (
    <Container>
      <Grid column={2}>
        <Row>
          <Column width={3}>
            <Header>Tester</Header>
          </Column>

          <Column width={3}>
            <Header>Expired On</Header>
          </Column>
        </Row>

        {isEmpty(testSessionsExpired)
          && <NoDataMessage>No expired test sessions found</NoDataMessage>}

        {!isEmpty(testSessionsExpired) && testSessionsExpired.map((testSessionExpired) => {
          const { id, tester } = testSessionExpired;
          const { user } = tester;

          return (
            <Row key={`${id}-${tester.id}`}>
              <Column width={3}>
                <ClickableData onClick={() => onSetCurrentTester(tester)}>
                  {`${user.profile.firstName} ${user.profile.lastName}`}
                </ClickableData>
              </Column>

              <Column width={3}>
                <Data>
                  {testSessionExpired.expiresAt && moment(testSessionExpired.expiresAt).format('MM/DD/YYYY hh:mm A')}
                </Data>
              </Column>

              <Column width={10} lastChild>
                {testType === 'unmoderated' && (
                  <>
                    {(testSessionExpired.status === 'transcribe_error' || testSessionExpired.status === 'error') && (
                      <>
                        <Link onClick={() => handleReprocessVideo(testSessionExpired.id)}>
                          Reprocess
                        </Link>
                        ,&nbsp;
                      </>
                    )}
                    <Link href={testSessionExpired.videoUrl} download>
                      Download
                    </Link>
                    ,&nbsp;
                  </>
                )}
                <Link onClick={() => navigator.clipboard.writeText(testSessionExpired.id)}>
                  Copy Tester Session ID
                </Link>
              </Column>
            </Row>
          );
        })}
      </Grid>
    </Container>
  );
};

ExpiredTesters.propTypes = {
  testType: string,
  onSetCurrentTester: func.isRequired,
  refetch: func.isRequired,
  projectId: string.isRequired,
};

ExpiredTesters.defaultProps = {
  testType: null,
};

export default ExpiredTesters;
